import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { FixedMarkerOverrides, FloatingMarker } from 'baseui/map-marker';
import { memo, useEffect } from 'react';
import { Marker, MarkerDragEvent } from 'react-map-gl/mapbox';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { editingPlaceState, editSelectedPlaceState } from '../../../storage/places';
import { getAddressFromPoint } from '../../../utils/geocode';

function PlaceMarker() {
  const [editingPlace, setEditingPlace] = useRecoilState(editingPlaceState);
  const isEditing = useRecoilValue(editSelectedPlaceState);
  const { zoomTo } = useCamera();

  useEffect(() => {
    if (!editingPlace?.geoPoint) return;
    const point = {
      lng: editingPlace.geoPoint.coordinates[0],
      lat: editingPlace.geoPoint.coordinates[1],
    };
    const isValidPoint = isValidLatitude(point.lat) && isValidLongitude(point.lng);
    if (isValidPoint) {
      zoomTo(point);
    }
  }, [editingPlace, zoomTo]);

  if (!editingPlace?.geoPoint) return null;

  const floatingMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  const point = {
    lng: editingPlace.geoPoint.coordinates[0],
    lat: editingPlace.geoPoint.coordinates[1],
  };

  const isValidPoint = isValidLatitude(point.lat) && isValidLongitude(point.lng);

  if (!isValidPoint) return null;

  const onDragEnd = async (event: MarkerDragEvent) => {
    const address = await getAddressFromPoint(event.lngLat);
    setEditingPlace((prev) => ({
      ...prev!,
      address: address ?? '',
      geoPoint: {
        ...prev!.geoPoint!,
        coordinates: [event.lngLat.lng, event.lngLat.lat],
      },
    }));
  };

  return (
    <Marker
      latitude={point.lat}
      longitude={point.lng}
      draggable={isEditing}
      onDragEnd={onDragEnd}
    >
      <FloatingMarker
        label={editingPlace.address}
        overrides={floatingMarkerOverrides}
        size="small"
        anchorType="circle"
      />
    </Marker>
  );
}

export default memo(PlaceMarker);
